<template>
  <div class="figma-sections" aria-hidden="true">
    <div
      v-for="section in sections"
      :key="section.id"
      class="figma-section"
      :style="sectionStyle(section)"
    >
      <img
        class="figma-section__image"
        :src="section.src"
        :srcset="section.srcset"
        sizes="100vw"
        width="1920"
        :height="section.sourceH ?? section.h"
        alt=""
        :loading="section.loading"
        decoding="async"
        :fetchpriority="section.fetchPriority"
        draggable="false"
        :style="imageStyle(section)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { CSSProperties } from 'vue'

import type { FigmaSection } from '../../data/home2026'

const props = defineProps<{
  sections: FigmaSection[]
  scaledPx: (value: number) => string
}>()

const sectionStyle = (section: FigmaSection): CSSProperties => ({
  top: props.scaledPx(section.y),
  height: props.scaledPx(section.h),
})

const imageStyle = (section: FigmaSection): CSSProperties => ({
  height: props.scaledPx(section.sourceH ?? section.h),
  transform:
    section.cropTop !== undefined ? `translateY(-${props.scaledPx(section.cropTop)})` : undefined,
})
</script>

<style scoped>
.figma-sections {
  position: absolute;
  z-index: 0;
  inset: 0;
  pointer-events: none;
}

.figma-section {
  position: absolute;
  left: 0;
  display: block;
  width: 100%;
  overflow: hidden;
  pointer-events: none;
}

.figma-section__image {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 100%;
  object-fit: fill;
  user-select: none;
  pointer-events: none;
}
</style>
